import React, { Component } from 'react';

import '../css/bg.css';
import '../css/main-page.css';

import $ from 'jquery';

class Home extends Component {

  constructor(props) {
    super(props);
    let lang = window.location.hash.split('/')[1];


    this.state = {
    	...this.props,
    	bg: {
	    	'pic1': '/bg/' + lang + '/home/main.png',
        'pic2': '/bg/' + lang + '/home/back-1.png',
	    	'pic3': '/bg/' + lang + '/home/front-1.png',
	    	'pic4': '/bg/' + lang + '/home/front-2.png'
	    },
      lang: lang
    }
    $('#loader').fadeIn();
  }
  
  componentWillMount() {
    
  }

  componentDidMount() {
    let t = this;
    this.props.updateLang();
    this.changePositioning();
    window.addEventListener('resize', this.changePositioning);


    $( "#bg-image-1" ).on('load', function() {
      t.pageLoad();
      document.getElementById('footer-panel-layer').style.zIndex = '1000';
      document.getElementById('footer-panel-layer').classList.add('show-footer-panel-layer');
    });
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.changePositioning);
  }

  pageLoad () {
    let t = this;
    t.props.bgImageOnload();

    setTimeout(function(){
      document.getElementById('bg-image-2').classList.remove('bg-flower');
    }, 2200);
    setTimeout(function(){
      document.getElementById('bg-image-3').classList.remove('bg-flower');
    }, 3000);
    setTimeout(function(){
      document.getElementById('bg-image-4').classList.remove('bg-flower');
    }, 3900);
  }

  changePositioning() {
    let windowWidth = $('.App').width();

    if (windowWidth < 1100) {
      windowWidth = 1100
    }

    let bgImage2Top = windowWidth * 0.545 + 'px';
    let bgImage4Top = windowWidth * 0.4 + 'px';

    document.getElementById('bg-image-2-container').style.top = bgImage2Top;
    document.getElementById('bg-image-4-container').style.top = bgImage4Top;
  }
  
  render() {
  	return <div className="main-page" style={{}}>
        <div id='bg-image-2-container'
          className='bg-image-container'
          style={{
            'right': '3px',
            'width': '50%'
          }}>
          <img src={this.state.bg.pic2} className='bg-image bg-flower' id='bg-image-2'/>
        </div>
    		<img src={this.state.bg.pic1} className='bg-image' id='bg-image-1' style={{}}/>
    		<img src={this.state.bg.pic3} className='bg-image bg-flower' id='bg-image-3' style={{
          'right': '0',
          'width': '25%'
        }}/>
        <div id='bg-image-4-container'
          className='bg-image-container'
          style={{
            'width': '40%'
          }}>
          <img src={this.state.bg.pic4} className='bg-image bg-flower' id='bg-image-4'/>
        </div>
  	</div>
  }

  // render() {
  //   return <div style={{}}>
  //       <img src={this.state.bg.pic1} className='bg-image' id='bg-image-1' style={{}}/>
  //       <img src={this.state.bg.pic2} className='bg-image bg-image-2' id='bg-image-2' style={{}}/>
  //       <img src={this.state.bg.pic3} className='bg-image bg-image-3' id='bg-image-3' style={{}}/>
  //   </div>
  // }
};

export default Home;



// WEBPACK FOOTER //
// ./src/page/Home.js